"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Medal24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "medal-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("circle", { id: "Oval-23", stroke: "#000000", strokeWidth: 2, cx: 12, cy: 16, r: 5 }),
            react_1.default.createElement("polygon", { id: "Star", fill: "#000000", points: "12 17.4341997 10.5002881 18.0213448 10.5952599 16.4135962 9.57341523 15.1687233 11.1318228 14.7622251 12 13.4057062 12.8681772 14.7622251 14.4265848 15.1687233 13.4047401 16.4135962 13.4997119 18.0213448" }),
            react_1.default.createElement("g", { id: "Group", transform: "translate(6.000000, 3.000000)", stroke: "#000000", strokeWidth: 2 },
                react_1.default.createElement("path", { d: "M11,1 L1,1 L1,4.68346024 L6,6.90568247 L11,4.68346024 L11,1 Z", id: "Rectangle" }),
                react_1.default.createElement("line", { x1: 8, y1: 0, x2: 8, y2: 6, id: "Line" }),
                react_1.default.createElement("line", { x1: 4, y1: 0, x2: 4, y2: 6, id: "Line-Copy" }))));
}
function Medal24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Medal24Svg, Object.assign({}, svgProps)));
}
exports.default = Medal24;
//# sourceMappingURL=Medal24.js.map